module.exports = __webpack_public_path__ + "img/myrna.b0e1bb82.png";